
import React from "react";
import styles from "./LoginPage.module.scss"
import { useForm } from "react-hook-form";
import axios from 'axios';

function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const onSubmit = (data: any) => formAction(data)
  return (
    <>
      <section className={styles.main}>
        <div className={styles.container}>
          <h2 className={styles.title}>Espace membre</h2>
          <form className={styles.formLogin} onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.formItem}>
              <label htmlFor="login">Pseudo <span className={styles.red}>*</span></label>
              <p><input type="text" placeholder="Login" id="login" {...register("login", {required: true})}/></p>
              {errors.lastName && <span className={styles.red}>Veuillez saisir votre nom !</span>}
            </div>
            <div className={styles.formItem}>
              <label htmlFor="Password">Mot de passe <span className={styles.red}>*</span></label>
              <p><input type="password" placeholder="Password" id="Password" {...register("Password", {required: true})}/></p>
              {errors.lastName && <span className={styles.red}>Veuillez saisir votre nom !</span>}
            </div>
            <div className={styles.formItem}>
              <p className={styles.blockSubmit}><input type="submit" name="login" value="Connexion" className={styles.button62}/></p>
            </div>
          </form>
          <div className={styles.omit}>
            <p className={styles.red}>Mot de passe oublié ? <a href="/register">Réinitialiser</a></p>
            </div>
        </div>
        </section>
    </>
  );
}

export default Login;

async function formAction(data: {login: string; password: string;}) {
  axios.post('https://labuzifpokerclub.fr/back/api/users/login.php', {
    login: data.login,
    password: data.password
  })
  .then(function (response) {
    console.log(response);
  })
  .catch(function (error) {
    console.log(error);
  });
}
